var image_viewer_rtlignore_default = {
  "fontElementMap": "j7e-i",
  "imageContainer": "OvGbF",
  "expandContainer": "PT7AV",
  "expandIcon": "K7vLS",
  "pointer": "rDel9",
  "imageWrapper": "ehKId",
  "imageRatio": "GlZn8",
  "image": "_3OC5q",
  "imageOverlay": "u-DzS",
  "imageCaption": "VH-CO",
  "imagePreload": "e5VYQ",
  "imageHighres": "pDLo-",
  "onlyHighRes": "DFXRA",
  "image_loading": "QDsgh"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
